import { Theme } from '@mui/material';

export const MuiButton = (theme: Theme) => ({
  styleOverrides: {
    root: {
      variants: [
        {
          props: { variant: 'contained', color: 'primary' },
          style: {
            color: theme.palette.common.black,
            fontSize: '16px',
            fontFamily: 'inherit',
            lineHeight: '137%',
            padding: '13px 28px',
            borderRadius: '12px',
            backgroundColor: theme.palette.green.main,
            boxShadow: 'none',
            textTransform: 'none',
            '@media (hover: hover)': {
              '&:hover': {
                transition: 'all 0.4s ease',
                backgroundColor: theme.palette.blue.dark,
              },
            },
            '@media (hover: none)': {
              '&:active': {
                backgroundColor: theme.palette.blue.dark,
              },
            },
            '&:disabled': {
              PointerEvent: 'none',
              backgroundColor: theme.palette.gray[150],
              color: theme.palette.gray[300],
            },
          },
        },
        {
          props: { variant: 'contained', color: 'warning' },
          style: {
            width: '100%',
            [theme.breakpoints.up('xs')]: {
              color: theme.palette.common.white,
              fontSize: '14px',
              fontFamily: 'inherit',
              lineHeight: '120%',
              padding: '12px 20px',
              borderRadius: '10px',
              border: `2px solid transparent`,
              boxShadow: 'none',
            },
            [theme.breakpoints.up('md')]: {
              color: theme.palette.common.white,
              fontSize: '18px',
              padding: '20px 30px',
              maxWidth: '100%',
            },
            '@media (hover: hover)': {
              '&:hover': {
                transition: 'all 0.4s ease',
                backgroundColor: theme.palette.blue.dark,
              },
            },
            '@media (hover: none)': {
              '&:active': {
                backgroundColor: theme.palette.blue.dark,
              },
            },
            '&:disabled': {
              PointerEvent: 'none',
              backgroundColor: theme.palette.gray[150],
              color: theme.palette.gray[300],
            },
          },
        },
        {
          props: { variant: 'text', color: 'primary' },
          style: {
            // [theme.breakpoints.up('xs')]: {
            color: theme.palette.gray.main,
            fontSize: '16px',
            fontWeight: 400,
            fontFamily: 'inherit',
            lineHeight: '137%',
            padding: '13px 0',
            textTransform: 'none',
            // },
            // },
            // '@media (hover: hover)': {
            //   '&:hover': {
            //     transition: 'all 0.4s ease',
            //     color: theme.palette.blue.dark,
            //   },
            // },
            // '@media (hover: none)': {
            //   '&:active': {
            //     color: theme.palette.blue.dark,
            //   },
            // },
            // '&:disabled': {
            //   PointerEvent: 'none',
            //   backgroundColor: theme.palette.gray[150],
            //   color: theme.palette.gray[300],
            // },
          },
        },
      ],
    },
  },
});
